<template>
  <div class="opc-cart__description __PLACEHOLDER_total__desc">
    <h3 v-if="proratedText" v-html="$t('billing.order_summary.prorated_title')"></h3>
    <p v-if="proratedText">{{ proratedText }}</p>
    <p>
      {{ this.isFreeTrialFlow ? $t('billing.order_summary.taxes_desc'): $t('billing.order_summary.taxes_desc2') }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { planTypes } from '@/common/constants';
export default {
  computed: {
    ...mapGetters(['isCurrentEditUpSell', 'editablePlansInBought', 'getSelectedPlans', 'mixBuyFlowContainsEditCase', 'migratePlanState', 'isfraudRiskOperation']),
    proratedText() {
      if (this.$context.is.add2cart) {
        // for one time plan
        if ([planTypes.MASTER_CLASS].includes(this.$context.type)) {
          return '';
        }

        return this.$t('billing.order_summary.prorated_upsell_desc');
      }
      if (this.migratePlanState.is.upgrade) return this.$t('billing.order_summary.prorated_upsell_desc');
      if (this.$context.is.pro2biz) return this.$t('billing.order_summary.prorated_upsell_desc');
      if (this.$context.is.zs2ze) return this.$t('billing.order_summary.prorated_upsell_desc');
      if (this.$context.is.downgrade) return this.$t('billing.order_summary.prorated_upsell_desc');
      if (this.$context.is.switch) return this.$t('billing.order_summary.prorated_upsell_desc');
      if (this.mixBuyFlowContainsEditCase) return this.$t('billing.order_summary.prorated_upsell_desc');
      if (this.$context.is.edit) {
        const deltas = [this.editablePlansInBought, this.getSelectedPlans].map((plans) => {
          const plan = plans[0]; // TODO multiple plan edits ?
          return {
            details: `${plan?.category},${plan?.cartInfo?.selected_number}`,
            cycle: `${plan?.billing_cycle}`,
          };
        });
        const isEditSingle = this.getSelectedPlans.length == 1;
        const isEditOnlyChangedCycle = deltas[0].details == deltas[1].details && deltas[0].cycle !== deltas[1].cycle;
        if (isEditSingle && (isEditOnlyChangedCycle || this.isfraudRiskOperation)) return this.$t('billing.order_summary.prorated_cycle_change_desc');
        if (this.isCurrentEditUpSell) return this.$t('billing.order_summary.prorated_upsell_desc');
        return '';
      }
      return '';
    },
    // BUY TRIAL
    // FREE TRIAL - special desc text for free trial
    isFreeTrialFlow() {
      return this.$context.is.add2trial || this.$context.is.buyTrial
    }
  },
};
</script>

<style lang="scss">
@import "description";
</style>
